import React, { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { Acesso, acessosDoAmbiente, alternarTodos, ArvoreAmbiente, chaveDoAcesso, porAmbiente } from './comum'
import './solicitacoes.scss'

interface Props {
  rotulo?: string
  /** O que a pessoa já acessa. Só isso pode ser pedido. */
  arvore: ArvoreAmbiente[]
  carregando?: boolean
  valor: Acesso[]
  aoMudar: (valor: Acesso[]) => void
}

/**
 * Escolher dashboards pelo ambiente: primeiro o ambiente, depois marcar os dashboards dele (agrupados por grupo,
 * com "marcar todos"). Dá para somar outros ambientes; o resumo embaixo agrupa tudo por ambiente.
 */
export default function SeletorAcesso({ rotulo = 'Dashboards', arvore, carregando, valor, aoMudar }: Props) {
  const [ambienteId, setAmbienteId] = useState<number | ''>('')
  const ambiente = arvore.find(a => a.id === ambienteId)

  useEffect(() => {
    if (ambienteId !== '' && !arvore.some(a => a.id === ambienteId)) setAmbienteId('')
  }, [arvore, ambienteId])

  const marcados = new Set(valor.map(chaveDoAcesso))
  const doAmbiente = ambiente ? acessosDoAmbiente(ambiente) : []
  const todos = doAmbiente.length > 0 && doAmbiente.every(a => marcados.has(chaveDoAcesso(a)))

  const alternar = (a: Acesso) => {
    const k = chaveDoAcesso(a)
    aoMudar(marcados.has(k) ? valor.filter(x => chaveDoAcesso(x) !== k) : [...valor, a])
  }
  const grupos = porAmbiente(valor)

  return (
    <div className="ng-campo sol-acesso">
      <span>{rotulo}</span>
      {carregando && <small className="sol-ajuda">Carregando o que você acessa…</small>}
      {!carregando && arvore.length === 0 && (
        <small className="sol-ajuda">Você ainda não acessa nenhum dashboard, então não há o que escolher aqui. Use a pessoa de referência ou as equipes.</small>
      )}

      {arvore.length > 0 && (<>
        <select value={ambienteId} onChange={e => setAmbienteId(e.target.value ? Number(e.target.value) : '')} aria-label="Ambiente dos dashboards">
          <option value="">Escolha o ambiente…</option>
          {arvore.map(a => <option key={a.id} value={a.id}>{a.nome}</option>)}
        </select>

        {ambiente && (
          <div className="sol-lista-dash">
            <div className="sol-lista-cab">
              <b>Dashboards de {ambiente.nome}</b>
              <button type="button" className="sol-link" onClick={() => aoMudar(alternarTodos(valor, ambiente))}>
                {todos ? 'Desmarcar todos' : 'Marcar todos'}
              </button>
            </div>
            {ambiente.grupos.map(g => (
              <div key={g.id}>
                <div className="sol-grupo">{g.nome}</div>
                {g.dashboards.map(d => {
                  const a: Acesso = { ambienteId: ambiente.id, ambienteNome: ambiente.nome, grupoId: g.id, grupoNome: g.nome, dashboardId: d.id, dashboardNome: d.nome }
                  return (
                    <label key={d.id} className="sol-marca">
                      <input type="checkbox" checked={marcados.has(chaveDoAcesso(a))} onChange={() => alternar(a)} />
                      {d.nome}
                    </label>
                  )
                })}
              </div>
            ))}
          </div>
        )}
      </>)}

      {grupos.length > 0 && (
        <div className="sol-resumo">
          <b>Você vai pedir ({valor.length})</b>
          {grupos.map(g => (
            <div key={g.ambienteId} className="sol-resumo-amb">
              <small className="sol-ajuda">{g.ambienteNome}</small>
              <div className="sol-etiquetas">
                {g.itens.map(a => (
                  <span key={chaveDoAcesso(a)} className="sol-etiqueta" title={`${a.ambienteNome} › ${a.grupoNome}`}>
                    {a.dashboardNome}
                    <button type="button" onClick={() => alternar(a)} aria-label={`Tirar ${a.dashboardNome} de ${a.ambienteNome}`}><CloseIcon fontSize="inherit" /></button>
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
